import SchoolLogo from './SchoolLogo.component';

export default SchoolLogo;